import Vue from 'vue'
import http from '@/http'
import createCrudModule from 'vuex-crud'
import { filter } from 'lodash'

let parseError = res => res
let parseSingle = res => res

export default createCrudModule({
  client: http,
  resource: 'complexes/objects',
  urlRoot: 'complexes/objects',

  state: {
    complexes: {},
    objectsList: []
  },

  mutations: {
    setObjectsList(state, objectsList) {
      state.objectsList = objectsList
    }
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.list,
      complex: response.data.complex
    })
  },

  onFetchListSuccess(state, { complex }) {
    if (complex) {
      Vue.set(state.complexes, [complex.id], complex)
    }
  },

  getters: {
    complexById: state => id => {
      return state.complexes[id] || {}
    },

    filter: state => identity => {
      return filter(state.entities, identity)
    }
  },

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`complexes/objects/${id}`, data, config)
        .then(res => {
          let parsedResponse = parseSingle(res)
          commit('updateSuccess', parsedResponse)
          return parsedResponse
        })
        .catch(err => {
          let parsedError = parseError(err)
          commit('updateError', parsedError)
          return Promise.reject(parsedError)
        })
    },

    getObjectsList({ commit }, complex_id) {
      return http.get(`data/1c/objects?complex_id=${complex_id}`).then(res => {
        let parsedResponse = parseSingle(res.data)
        commit('setObjectsList', parsedResponse)
        return parsedResponse
      })
    },

    destroyGuidLink(_, link) {
      return http
        .delete(`complexes/objects/${link.object_id}/link/${link.id}`)
        .then(res => {
          let parsedResponse = parseSingle(res.data)
          return parsedResponse
        })
    },

    linkGuid({ commit }, guidItem) {
      return http
        .post(`complexes/objects/${guidItem.object_id}/link`)
        .then(res => {
          let parsedResponse = parseSingle(res.data)
          commit('linkGuid', parsedResponse)
          return parsedResponse
        })
    }
  }
})
